module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 d-flex flex-wrap py-3"
  }, [_c('div', {
    staticClass: "col-sm-6 d-flex flex-column h-100"
  }, [_c('client-form', {
    staticClass: "flexGrow1",
    attrs: {
      "disabled": _vm.disabled,
      "customer": _vm.reservation.customer,
      "bookingComponents": _vm.reservation.bookingComponents,
      "transport": _vm.reservation.transport,
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 border-light radius-normal"
  }, [_c('checkins', {
    attrs: {
      "disabled": _vm.disabled,
      "reservation": _vm.reservation
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-2"
  }, [_c('div', {
    staticClass: "col-sm-12 border-light radius-normal"
  }, [_c('price-total', {
    attrs: {
      "disabled": _vm.disabled,
      "reservation": _vm.reservation
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbf608e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabDetails.vue
// module id = 1648
// module chunks = 0